import Vue from 'vue'
import i18n from '@/i18n'
import PdfMake from 'pdfmake/build/pdfmake'
import PdfFonts from 'pdfmake/build/vfs_fonts'

Vue.mixin({
  methods: {
    exportRegistration (registration, headerImage) {
      PdfMake.vfs = PdfFonts.pdfMake.vfs

      const header = []
      if (!this.browserIE11()) {
        header.push({
          image: this.getBase64Image(headerImage),
          width: 40,
          height: 65,
          alignment: 'left'
        })
      }
      header.push({ text: '\n\n' + 'Република Србија' + '\n' + 'МИНИСТАРСТВО ФИНАНСИЈА', fontSize: 10 })
      header.push({ text: '\n\n' + 'Образац ПИМИС-1' + '\n' + 'Платформа за управљање капиталним пројектима', fontSize: 10, alignment: 'right' })

      var docDefinition = {
        content: [
          {
            columns: header
          },
          { text: '\n\n' + i18n.t('organizationAdministration.registrationFormTitle') + '\n\n\n', style: 'header' },
          { text: i18n.t('organizationAdministration.legalEntityInfo') + '\n\n', style: 'subheader' },
          { text: i18n.t('organizationAdministration.budgetUserId') + ' : ', style: 'caption' },
          { text: registration.id + '\n\n', style: 'value' },
          { text: i18n.t('organizationAdministration.companyName') + ' : ', style: 'caption' },
          { text: registration.name + '\n\n', style: 'value' },
          {
            columns:
            [
              [
                { text: i18n.t('organizationAdministration.companyNumber') + ' : ', style: 'caption' },
                { text: registration.companyNumber + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('organizationAdministration.taxIdNumber') + ' : ', style: 'caption' },
                { text: registration.taxIdNumber + '\n\n', style: 'value' }
              ]
            ]
          },
          { text: i18n.t('organizationAdministration.address') + ' : ', style: 'caption' },
          { text: registration.address + '\n\n', style: 'value' },
          {
            columns:
            [
              [
                { text: i18n.t('organizationAdministration.email') + ' : ', style: 'caption' },
                { text: registration.email + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('general.phone') + ' : ', style: 'caption' },
                { text: registration.phoneNumber + '\n\n\n', style: 'value' }
              ]
            ]
          },
          { text: i18n.t('organizationAdministration.adminInfo') + '\n\n', style: 'subheader' },
          {
            columns:
            [
              [
                { text: i18n.t('organizationAdministration.name') + ' : ', style: 'caption' },
                { text: registration.adminName + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('organizationAdministration.identityNumber') + ' : ', style: 'caption' },
                { text: registration.adminIdentityNumber + '\n\n\n', style: 'value' }
              ]
            ]
          },
          {
            columns:
            [
              [
                { text: i18n.t('organizationAdministration.email') + ' : ', style: 'caption' },
                { text: registration.adminEmail + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('general.phone') + ' : ', style: 'caption' },
                { text: registration.adminPhoneNumber + '\n\n\n', style: 'value' }
              ]
            ]
          },
          {
            columns:
            [
              { text: '_____________________________', style: 'caption', alignment: 'right', margin: [0, 35, 15, 5] }
            ]
          },
          {
            columns:
            [
              { text: 'М.П. Потпис одговорног лица' + '\n\n\n', fontSize: 11, alignment: 'right', margin: [0, 0, 15, 0] }
            ]
          }
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            alignment: 'center'
          },
          value: {
            fontSize: 11,
            bold: false
          },
          caption: {
            fontSize: 11,
            bold: true
          },
          subheader: {
            fontSize: 13,
            bold: true
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 9
          }
        }
      }
      PdfMake.createPdf(docDefinition).download('pimis-registracija-' + registration.id + '.pdf')
    },
    exportAdminForm (registration, headerImage) {
      PdfMake.vfs = PdfFonts.pdfMake.vfs

      const header = []
      if (!this.browserIE11()) {
        header.push({
          image: this.getBase64Image(headerImage),
          width: 40,
          height: 65,
          alignment: 'left'
        })
      }

      header.push({ text: '\n\n' + 'Република Србија' + '\n' + 'МИНИСТАРСТВО ФИНАНСИЈА', fontSize: 10 })
      header.push({ text: '\n\n' + 'Образац ПИМИС-2' + '\n' + 'Платформа за управљање капиталним пројектима', fontSize: 10, alignment: 'right' })

      var docDefinition = {
        maxPagesNumber: 1,
        content: [
          {
            columns: header
          },
          { text: '\n\n' + i18n.t('organizationAdministration.printAdminFormTitle') + '\n\n\n', style: 'header' },
          { text: i18n.t('organizationAdministration.legalEntityInfo') + '\n\n', style: 'subheader' },
          { text: i18n.t('organizationAdministration.budgetUserId') + ' : ', style: 'caption' },
          { text: registration.id + '\n\n', style: 'value' },
          { text: i18n.t('organizationAdministration.companyName') + ' : ', style: 'caption' },
          { text: registration.name + '\n\n', style: 'value' },
          {
            columns:
            [
              [
                { text: i18n.t('organizationAdministration.companyNumber') + ' : ', fontSize: 12 },
                { text: registration.companyNumber + '\n\n', style: 'value' }
              ],
              [
                { text: i18n.t('organizationAdministration.taxIdNumber') + ' : ', fontSize: 12 },
                { text: registration.taxIdNumber + '\n\n', style: 'value' }
              ]
            ]
          },
          { text: i18n.t('organizationAdministration.address') + ' : ', fontSize: 12 },
          { text: registration.address + '\n\n', style: 'value' },
          { text: i18n.t('registration.adminInfo') + '\n\n', style: 'subheader' },
          { text: i18n.t('userAdministration.userLogin') + ' : ', fontSize: 12 },
          { text: (registration.adminLogin || '') + '\n\n', style: 'value' },
          { text: i18n.t('registration.name') + ' : ', fontSize: 12 },
          { text: (registration.adminName || '') + '\n\n', style: 'value' },
          { text: i18n.t('general.email') + ' : ', fontSize: 12 },
          { text: (registration.adminEmail || '') + '\n\n', style: 'value' },
          {
            columns:
            [
              { text: '__________________________', fontSize: 12, alignment: 'left', margin: [15, 100, 0, 5] },
              { text: '__________________________', fontSize: 12, alignment: 'right', margin: [0, 100, 15, 5] }
            ]
          },
          {
            columns:
            [
              { text: 'Предао', fontSize: 10, alignment: 'left', margin: [65, 0, 0, 0] },
              { text: 'Примио', fontSize: 10, alignment: 'right', margin: [0, 0, 70, 0] }
            ]
          }
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            alignment: 'center'
          },
          value: {
            fontSize: 11,
            bold: false
          },
          caption: {
            fontSize: 11,
            bold: true
          },
          subheader: {
            fontSize: 13,
            bold: true
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 9
          }
        }
      }
      PdfMake.createPdf(docDefinition).download('pimis-potvrda-' + registration.id + '.pdf')
    },
    getBase64Image (img) {
      if (this.browserIE11()) { return }

      // Create an empty canvas element
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height

      // Copy the image contents to the canvas
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)

      return canvas.toDataURL('image/png')
    }
  }
})
